import styled from 'styled-components';
import { palette } from 'styles/colors';
import { layout } from 'styles/layout';

// margin-top: -120px !important; and margin-bottom: -30px !important;
// are needed to override the section layout of margin: 0 auto;
export const OrderedListSectionWrapper = styled.div`
  position: relative;
  color: ${palette.white};
  max-width: none !important;
  width: 100%;
  padding-top: 120px;
  margin-top: -120px !important;
  padding-bottom: 30px;
  margin-bottom: -30px !important;
  text-align: center;
  overflow-y: visible;
  z-index: 1;

  h1 {
    max-width: 760px;
    margin: 0 auto 16px;
    line-height: 1.14;
    padding: 0 30px;

  }
`;

export const SectionBackgroundImage = styled.div`
  position: absolute;
  left: 0px;
  top: 101px;
  width: 100vw;
  height: calc(100% - 198px);
  z-index: -1;
  background: ${palette.proBlue};
  @media all and (max-width: ${layout.lg}) {
    height: calc(100% - 160px);
  }
  
  &::before {
    content: '';
    position: absolute;
    height: 100px;
    width: 100%;
    top: -99px;
    left: 0px;
    background: ${palette.proBlue};
    clip-path: polygon(100% 0%,100% 0%,100% 100%,0% 100%,0% 100%);
    @media all and (max-width: ${layout.lg}) {
      height: 50px;
      top: -49px;
    }
  }
  &::after {
    content: '';
    position: absolute;
    height: 100px;
    width: 100%;
    bottom: -99px;
    left: 0px;
    background: ${palette.proBlue};
    clip-path: polygon(0% 0%,100% 0%,100% 100%,100% 79%,0% 0%);
    
    @media all and (max-width: ${layout.lg}) {
      height: 50px;
      bottom: -49px;
    }
  }
`;

export const StyledOrderedList = styled.ol`
  position: relative;
  max-width: 250px;
  list-style: none;
  counter-reset: decimal-counter;
  display: flex;
  flex-wrap: wrap;
  margin: 25px auto;
  padding: 0;

  @media screen and (min-width: ${layout.md}) {
    max-width: 470px;
  }
`;

export const StyledListItem = styled.li`
  counter-increment: decimal-counter;
  display: flex;
  flex-direction: column;
  padding-left: 56px;
  position: relative;
  font-size: 24px;
  padding-bottom: 35px;

  @media screen and (min-width: ${layout.md}) {
    padding-bottom: 50px;

    p {
      font-size: 25px;
    }
  }

  &:before {
    content: counter(decimal-counter);
    display: block;
    position: absolute;
    left: 5px;
    background: #fff;
    color: #1cabbf;
    border-radius: 100%;
    font-weight: 700;
    line-height: 20px;
    width: 20px;
    height: 20px;
    z-index: 2;
    font-size: 12px;
    text-align: center;

    @media screen and (min-width: ${layout.md}) {
      left: 0;
      width: 30px;
      height: 30px;
      line-height: 30px;
      font-size: 19px;
    }
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 13px;
    width: 0;
    border: 2px solid #fff;
    z-index: 1;
    bottom: 5px;
    top: 25px;

    @media screen and (min-width: ${layout.md}) {
      top: 35px;
    }
  }

  &:last-child:after {
    display: none;
  }
`;

export const ListItemTitle = styled.p`
  font-weight: 700;
  font-size: 25px;
`;
